import { render, staticRenderFns } from "./CmgCheckoutOrderDetailsTips.vue?vue&type=template&id=3342ebc6&scoped=true&lang=pug&"
import script from "./cmg-checkout-order-details-tips.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout-order-details-tips.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckoutOrderDetailsTips.vue?vue&type=style&index=0&id=3342ebc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3342ebc6",
  null
  
)

export default component.exports